import { isBefore as isBeforeDateFn, isAfter as isAfterDateFn } from 'date-fns';

export const isBefore = (date: Date, dateToCompare: Date) =>
  isBeforeDateFn(date, dateToCompare);

export const isAfter = (date: Date, dateToCompare: Date) =>
  isAfterDateFn(date, dateToCompare);
